import { combineReducers } from "redux";
import { reducerUserDetails } from "./otpVerificationDetails/reducer";

export default combineReducers({
   reducerUserDetails
})